<template>
    <div class="law-point-section">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <h1 class="text-center" style="margin-bottom: 50px;">Leistungen</h1>
                </div>
            </div>
            <div class="row" v-if="isListMode">
                <div class="col-sm-4" v-for="(service, key) in services" :key="key">
                    <ServiceItem :image="service.image" :title="service.title"
                                 :inner-title="service.innerTitle" :description="service.description"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ServiceItem from './ServiceItem';

    export default {
        name: 'Service',
        components: {
            ServiceItem
        },
        data () {
            return {
                isListMode: true,
                services: [
                    {
                        image: 'images/icon/about-icon-1.png',
                        title: 'Rechtsberatung bei Gründung',
                        innerTitle: 'Rechtsberatung bei Gründung',
                        description: 'Ich berate und begleite Sie bei verschiedenen Rechtsfragen'
                    },
                    {
                        image: 'images/icon/about-icon-3.png',
                        title: 'Förder- u. Finanzierungsberatung',
                        innerTitle: 'Förder- u. Finanzierungsberatung',
                        description: 'Ich berate und begleite Sie bei allen Fragen rund um die Themen Finanzierung und Förderung'
                    },
                    {
                        image: 'images/icon/about-icon-2.png',
                        title: 'Vermittlung von Geschäftskontakten',
                        innerTitle: 'Vermittlung von Geschäftskontakten',
                        description: 'Vermittlung von Geschäftskontakten'
                    }
                ]
            };
        },
        methods: {}
    };
</script>
